// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { forwardRef, Ref } from "react";
import { IconProps, Svg } from "@/frameworks/designStuff/components/Contents/Icon";
const SvgSearchList24 = forwardRef(
	({ size, title, desc, titleid, descid, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
		let ariaLabelledBy = titleid ? titleid : "";
		ariaLabelledBy += desc && descid ? ` ${descid}` : "";
		ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
		props["aria-labelledby"] = ariaLabelledBy;
		return (
			<Svg
				width={size}
				height={size}
				viewBox="0 0 24 24"
				xmlns="http://www.w3.org/2000/svg"
				title={title}
				titleid={titleid}
				desc={desc}
				descid={descid}
				aria-labelledby={ariaLabelledBy}
				aria-hidden={!ariaLabelledBy}
				ref={ref}
				{...props}
			>
				{!!title && <title id={titleId}>{title}</title>}
				{!!desc && <desc id={descId}>{desc}</desc>}
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M9.75 5.75C9.75 5.33579 9.41421 5 9 5H3C2.58579 5 2.25 5.33579 2.25 5.75C2.25 6.16421 2.58579 6.5 3 6.5H9C9.41421 6.5 9.75 6.16421 9.75 5.75ZM7.65909 10.75C7.65909 10.3358 7.3233 10 6.90909 10H3C2.58579 10 2.25 10.3358 2.25 10.75C2.25 11.1642 2.58579 11.5 3 11.5H6.90909C7.3233 11.5 7.65909 11.1642 7.65909 10.75ZM9 15C9.41421 15 9.75 15.3358 9.75 15.75C9.75 16.1642 9.41421 16.5 9 16.5H3C2.58579 16.5 2.25 16.1642 2.25 15.75C2.25 15.3358 2.58579 15 3 15H9ZM19.75 11C19.75 8.37665 17.6234 6.25 15 6.25C12.3766 6.25 10.25 8.37665 10.25 11C10.25 13.6234 12.3766 15.75 15 15.75C15.8466 15.75 16.6414 15.5285 17.3297 15.1404L20.7197 18.5303C21.0126 18.8232 21.4874 18.8232 21.7803 18.5303C22.0732 18.2374 22.0732 17.7626 21.7803 17.4697L18.5105 14.1999C19.2805 13.3556 19.75 12.2326 19.75 11ZM11.75 11C11.75 9.20507 13.2051 7.75 15 7.75C16.7949 7.75 18.25 9.20507 18.25 11C18.25 12.7949 16.7949 14.25 15 14.25C13.2051 14.25 11.75 12.7949 11.75 11Z"
				/>
			</Svg>
		);
	}
);
SvgSearchList24.defaultProps = {
	size: 24,
	focusable: false,
	"aria-hidden": true,
	role: "img",
	fill: "currentcolor"
};
export default SvgSearchList24;
